import Select from 'react-select';
import translations from '../../../../../../translations';
import { isNullOrEmpty } from '../../../../../../utils/guard';
import { getSharedStyles } from '../../../../../../utils/select';
import FormGroup from '../../../../../generic/FormGroup';
import { COMPONENT_TYPE } from '../../../../constants';
import { usePageEditor } from '../../../PageEditorProvider';
import { usePageCondition } from '../PageConditionsProvider';

/**
 * The configuration for the outcome a condition moves the flow on with, which is held as
 * progressOutcomePageComponentId against the page condition. The condition points at an Outcomes component on the page
 * rather than at an outcome, because outcomes belong to the map element and a page can be used by any number of map
 * elements. Each of those map elements binds its own outcome to the component, and that is the outcome the flow
 * progresses on.
 */
const PageConditionOutcomeConfig = () => {
    const { state: pageBuilderState } = usePageEditor();
    const { pageComponents } = pageBuilderState.page;
    const { state: pageConditionState, updateProgressOutcomeComponent } = usePageCondition();
    const { condition } = pageConditionState;

    // Only an Outcomes component can have outcomes bound to it, so it is the only kind worth offering here.
    const outcomeComponentOptions = (pageComponents ?? [])
        .filter(
            (pageComponent) =>
                pageComponent.componentType?.toUpperCase() === COMPONENT_TYPE['OUTCOMES'],
        )
        .map((pageComponent) => ({
            label: pageComponent.developerName || '',
            value: pageComponent.id || '',
        }));

    const selectedOutcomeComponent =
        outcomeComponentOptions.find(
            (option) => option.value === condition?.progressOutcomePageComponentId,
        ) ?? null;

    return (
        <div className="sidebar-mini-editor" data-testid="outcome-editor">
            <h4 className="sidebar-section-heading">Trigger outcome</h4>
            <FormGroup
                label="Outcomes component"
                htmlFor="progress-outcome-page-component"
                isValid={!isNullOrEmpty(selectedOutcomeComponent)}
                validationMessage={translations.PAGE_BUILDER_field_is_required_validation_message}
                showValidation={true}
                isRequired
            >
                <Select
                    inputId="progress-outcome-page-component"
                    className="select-field"
                    styles={getSharedStyles<(typeof outcomeComponentOptions)[number] | null>()}
                    options={outcomeComponentOptions}
                    // Clearing the select means no outcome at all, which is held as null rather than as an empty id.
                    onChange={(newComponent) =>
                        updateProgressOutcomeComponent(newComponent?.value ?? null)
                    }
                    placeholder="Select an Outcomes component"
                    value={selectedOutcomeComponent}
                    noOptionsMessage={() => 'No Outcomes components on this page'}
                    isClearable
                />
            </FormGroup>
        </div>
    );
};

export default PageConditionOutcomeConfig;
